import {
    SET_MODULES_CLE_LOADING,
    SET_MODULES_CLE_BULK_LOADING,
    SET_MODULES_CLE_ERROR,
    FETCH_MODULES_CLE_SUCCESS,
    FETCH_MODULES_CLE_FAIL,
    CREATE_MODULE_CLE_FAIL,
    UPDATE_MODULE_CLE_FAIL,
    DELETE_MODULE_CLE_SUCCESS,
    DELETE_MODULE_CLE_FAIL,
    DOWNLOAD_MODULE_CLE_TEMPLATE_FAIL,
    IMPORT_MODULE_CLE_EXCEL_REQUEST,
    IMPORT_MODULE_CLE_EXCEL_SUCCESS,
    IMPORT_MODULE_CLE_EXCEL_FAIL,
    CLEAR_MODULE_CLE_IMPORT_RESULT,
} from "../actions/modulesCleActions";

const initialState = {
    loading: false,
    bulkLoading: false,
    error: null,
    modulesCle: [],
    importResult: null,
};

export default function modulesCleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULES_CLE_LOADING:
            return { ...state, loading: action.payload };
        case SET_MODULES_CLE_BULK_LOADING:
            return { ...state, bulkLoading: action.payload };
        case SET_MODULES_CLE_ERROR:
            return { ...state, error: action.payload };
        case CLEAR_MODULE_CLE_IMPORT_RESULT:
            return { ...state, importResult: null };

        case FETCH_MODULES_CLE_SUCCESS:
            return { ...state, modulesCle: action.payload || [], error: null };

        case IMPORT_MODULE_CLE_EXCEL_REQUEST:
            return { ...state, bulkLoading: true, error: null, importResult: null };

        case IMPORT_MODULE_CLE_EXCEL_SUCCESS:
            return { ...state, bulkLoading: false, importResult: action.payload || null, error: null };

        case FETCH_MODULES_CLE_FAIL:
        case CREATE_MODULE_CLE_FAIL:
        case UPDATE_MODULE_CLE_FAIL:
        case DELETE_MODULE_CLE_FAIL:
            return { ...state, error: action.payload };

        case DOWNLOAD_MODULE_CLE_TEMPLATE_FAIL:
        case IMPORT_MODULE_CLE_EXCEL_FAIL:
            return { ...state, bulkLoading: false, error: action.payload };

        case DELETE_MODULE_CLE_SUCCESS:
            return { ...state, modulesCle: state.modulesCle.filter((x) => x.id !== action.payload), error: null };

        default:
            return state;
    }
}
